import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import InstallForm from '../Pages/Install';
import Home from '../Pages/Home';
import BestAllele from '../Pages/BestAllele';
import Users from '../Pages/Users';
import LoginForm from '../Pages/Login';
import SetPasswordPage from '../Pages/SetPassword';
import UserProfile from '../Pages/UserProfile';
import Settings from '../Pages/Settings';
import { AuthProvider } from '../Components/AuthContext';

function App() {
  return (
    <AuthProvider> 
    <Router>
      <Routes>
        {/* Redirect root to install for testing */}
        <Route path="/" element={<Navigate to="install" />} />
        
        {/* Install route */}
        <Route path="/install" element={<InstallForm />} />
        <Route path="/set-password" element={<SetPasswordPage />} />
        <Route path="/:tenantDomain/login" element={<LoginForm />} />
        <Route path="/:tenantDomain/home" element={<Home />} />
        <Route path="/:tenantDomain/best-allele" element={<BestAllele />} />
        <Route path="/:tenantDomain/users" element={<Users />} />
        <Route path="/:tenantDomain/user/:userId" element={<UserProfile />} />
        <Route path="/:tenantDomain/settings" element={<Settings />} />
        {/* Catch all other routes */}
        <Route path="*" element={<div>Page not found</div>} />
      </Routes>
    </Router>
    </AuthProvider> 
  );
}

export default App;
